import { EVENT_TYPES, STATUS_LABELS, RELIABILITY, normRel } from "@/lib/events";
import { ShieldCheck } from "lucide-react";

export const TypeBadge = ({ type }) => {
  const t = EVENT_TYPES[type] || EVENT_TYPES.manifestation;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] uppercase font-extrabold tracking-wider px-2.5 py-1 rounded-full border ${t.border} ${t.text} bg-slate-900/60`}>
      <span className="h-2 w-2 rounded-full" style={{ background: t.color }} />
      {t.label}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const map = {
    en_cours: "bg-emerald-950/80 text-emerald-400 border-emerald-500/50",
    prevu: "bg-amber-950/80 text-amber-400 border-amber-500/50",
    termine: "bg-slate-800 text-slate-400 border-slate-700",
  };
  return (
    <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full border ${map[status] || map.prevu}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
};

export const ReliabilityBadge = ({ reliability }) => {
  const r = RELIABILITY[normRel(reliability)] || RELIABILITY.annonce;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-bold px-2.5 py-1 rounded-full border ${r.badge}`}>
      <span aria-hidden>{r.glyph}</span> {r.label}
    </span>
  );
};

export const ProposalBadge = ({ count }) => (
  <span className="inline-flex items-center gap-1 text-[11px] font-bold px-2.5 py-1 rounded-full border bg-sky-950/80 text-sky-300 border-sky-500/50">
    <ShieldCheck size={12} /> Vérifié ({count || 2} propositions)
  </span>
);
